import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { format } from '@medflex/i18n';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import Button from '../Button';
import { IconEditPencil } from '../Icons';
import EmptystateButton from './EmptystateButton';
import Badge, { KINDS } from '../Badge';

const Status = ({ onClick, status, statusSetAt, upgrade }) => {
  const { t } = useTranslation('components');
  const isWideScreen = useIsWideScreen();
  return (
    <div data-component="PhysicianWelcomeScreen__Status" className="mb-8">
      <h2 className="font-semibold text-xl mb-2 text-slate-500 flex-1 flex items-center space-x-2">
        {t('physician_welcome_screen.status.title', { allowHtml: true })}
      </h2>
      {status ? (
        <div className="w-full border bg-white flex flex-row items-center p-4 space-x-4">
          <div className="text-slate-500">{status ? format(statusSetAt, 'DD.MM.YYYY') : ''}</div>
          <div className={`w-full truncate ${!status ? 'text-center' : ''}`}>
            {status || t('physician_welcome_screen.status.no_status_set.info')}
          </div>
          <div>
            {isWideScreen ? (
              <Button onClick={onClick}>{t('physician_welcome_screen.status.button_text')}</Button>
            ) : (
              <Button shape="square" onClick={onClick}>
                <IconEditPencil size="5" />
              </Button>
            )}
          </div>
        </div>
      ) : (
        <EmptystateButton onClick={onClick}>
          <span>{t('physician_welcome_screen.status.no_status_set.info')}</span>{' '}
          <span className="text-blue-500 ml-1 group-hover:underline">
            {t('physician_welcome_screen.status.no_status_set.button_text')}
          </span>
          {upgrade && (
            <Badge className="ml-2" kind={KINDS.SIGNAL}>
              {t('physician_welcome_screen.status.upgrade')}
            </Badge>
          )}
        </EmptystateButton>
      )}
    </div>
  );
};

Status.defaultProps = {
  onClick: () => {},
  status: '',
  statusSetAt: '',
  upgrade: false,
};

Status.propTypes = {
  onClick: PropTypes.func,
  status: PropTypes.string,
  statusSetAt: PropTypes.string,
  upgrade: PropTypes.bool,
};

export default Status;
